import FeatureSectionSix, { FeatureSectionSixProps } from './FeatureSectionSix'

export default FeatureSectionSix

export { FeatureSectionSix }
export type { FeatureSectionSixProps }
